import { getProductData } from "../components/utilities";

const LoadPurchase = {
  init: function () {
    const products = document.querySelectorAll('[data-product-box]:not([data-product-unique-id])')

    const observer = new IntersectionObserver(async (entries) => {
      const intersecting = entries.filter(entry => entry.isIntersecting)
      if (intersecting.length === 0) return

      const firstProduct = intersecting[0].target
      const productId = firstProduct.getAttribute('data-product-box')
      if (!productId) return

      let scriptUrl
      try {
        const { data } = await getProductData(productId)
        const hasDefault = data?.variants?.[0]?.custom_attributes &&
          typeof data.variants[0].custom_attributes === 'object' &&
          Object.keys(data.variants[0].custom_attributes).length > 0

        if (hasDefault && window.purchaseScriptDefault) {
          scriptUrl = window.purchaseScriptDefault
        } else if (window.purchaseScriptLegacy) {
          scriptUrl = window.purchaseScriptLegacy
        }
      } catch (e) {
        scriptUrl = window.purchaseScriptDefault || window.purchaseScriptLegacy
      }

      scriptUrl = scriptUrl || window.purchaseScriptDefault || window.purchaseScriptLegacy

      const scriptEl = document.createElement('script')
      scriptEl.src = scriptUrl
      document.body.appendChild(scriptEl)
      observer.disconnect()
    }, { threshold: 0.1 })

    products.forEach(product => observer.observe(product))
  }
}

export default LoadPurchase
